import React from 'react';
import { Link } from 'react-router-dom';

import style from './ForgotPasswordThankYouPage.module.css';

const ForgotPasswordThankYouPage = React.memo(() => {
  return (
    <section className={style.thankYou}>
      <h2 className={style.h2}>
        An email has been sent to your mailbox with a link to reset your
        password
      </h2>
      <div className={`container ${style.container}`}>
        <div className="row">
          <div className={style.wrapper}>
            <p className={style.note}>The link will expire in 1 hour.</p>
            <Link to="/login" className={`btn btn-default ${style.loginBtn}`}>
              Go Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
});

export default ForgotPasswordThankYouPage;
